import { render, staticRenderFns } from "./sent.vue?vue&type=template&id=19ce4017&scoped=true&"
import script from "./sent.vue?vue&type=script&lang=js&"
export * from "./sent.vue?vue&type=script&lang=js&"
import style0 from "./sent.vue?vue&type=style&index=0&id=19ce4017&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ce4017",
  null
  
)

export default component.exports